import {
  ENDPOINT_MERCHANT_PROMO_CREATE,
  ENDPOINT_MERCHANT_PROMO_DETAILS,
  ENDPOINT_MERCHANT_PROMO_UPDATE
} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const {
  apiRequest,
} = require('../ws');


export function apiPromoGet(params) {
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {});
  }
  return apiRequest(ENDPOINT_MERCHANT_PROMO_DETAILS, params).catch((error) => {
    // The promo not found
    if (error.code === 98) {
      return null;
    }
    throw error;
  });
}
export function apiPromoCreate(params) {
  if (process.env.MOCK) {
    console.log('apiPromoCreate', params);
    return CancelablePromise.delay(500, {});
  }
  return apiRequest(ENDPOINT_MERCHANT_PROMO_CREATE, params);
}
export function apiPromoUpdate(params) {
  if (process.env.MOCK) {
    console.log('apiPromoCreate', params);
    return CancelablePromise.delay(500, {});
  }
  return apiRequest(ENDPOINT_MERCHANT_PROMO_UPDATE, params);
}
